var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled colors"},_vm._l((_vm.colors),function(aColor){return _c('li',{key:aColor,staticClass:"color",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit("select", aColor)}}},[_c('span',{staticClass:"square rounded shadow-sm",style:({ backgroundColor: aColor })})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }